import React from "react";
import { CURRENCY_SELECT } from "../../../constants";

export const CurrencySelect = (props) => {
  return (
    <select 
      className="currency-selector"
      onChange={(e) => props.changeGlobalCurrency(e.target.value)}
    >
      {CURRENCY_SELECT.map((item) => {
        return (
          <option
            name={item.name}
            value={item.value}
            key={item.name}
            currencysymbol={item.symbol}
          >
            {item.name}
          </option>
        );
      })}
    </select>
  );
};
